/* ChristmasTime — śnieg, konfetti, odliczanie, demo kurtyny LED */
(function(){
  var reduced=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- śnieg + konfetti (jeden canvas) ---------- */
  var fx=document.getElementById('xm-fx'),flakes=[],bits=[],W=0,H=0,fxCtx=null;
  var COLORS=['#ff3d5a','#ffc93c','#1fd18a','#4cc3ff','#ff5fb7','#8b6cff','#ffffff'];
  function fxSize(){
    var d=Math.min(window.devicePixelRatio||1,2);W=window.innerWidth;H=window.innerHeight;
    fx.width=W*d;fx.height=H*d;fxCtx.setTransform(d,0,0,d,0,0);
  }
  function newFlake(top){
    return{x:Math.random()*W,y:top?-10:Math.random()*H,r:1+Math.random()*2.6,v:.35+Math.random()*.9,s:Math.random()*6.28,a:.35+Math.random()*.5};
  }
  function fxLoop(){
    if(!document.hidden){
      fxCtx.clearRect(0,0,W,H);
      fxCtx.fillStyle='#fff';
      for(var i=0;i<flakes.length;i++){var f=flakes[i];
        f.y+=f.v;f.s+=.012;f.x+=Math.sin(f.s)*.5;
        if(f.y>H+10)flakes[i]=newFlake(true);
        fxCtx.globalAlpha=f.a;fxCtx.beginPath();fxCtx.arc(f.x,f.y,f.r,0,6.28);fxCtx.fill();
      }
      for(var j=bits.length-1;j>=0;j--){var b=bits[j];
        b.vy+=.22;b.x+=b.vx;b.y+=b.vy;b.rot+=b.vr;b.life-=1;
        if(b.life<=0||b.y>H+20){bits.splice(j,1);continue;}
        fxCtx.globalAlpha=Math.min(1,b.life/30);fxCtx.fillStyle=b.c;
        fxCtx.save();fxCtx.translate(b.x,b.y);fxCtx.rotate(b.rot);fxCtx.fillRect(-b.w/2,-b.h/2,b.w,b.h);fxCtx.restore();
      }
      fxCtx.globalAlpha=1;
    }
    requestAnimationFrame(fxLoop);
  }
  window.xmConfetti=function(x,y,n){
    if(!fxCtx||reduced)return;
    for(var i=0;i<(n||40);i++){var a=Math.random()*6.28,sp=3+Math.random()*7;
      bits.push({x:x,y:y,vx:Math.cos(a)*sp,vy:Math.sin(a)*sp-4,w:5+Math.random()*6,h:8+Math.random()*7,rot:Math.random()*6.28,vr:(Math.random()-.5)*.4,c:COLORS[i%COLORS.length],life:70+Math.random()*40});
    }
  };
  if(fx&&!reduced){
    fxCtx=fx.getContext('2d');fxSize();
    var amount=parseInt(fx.getAttribute('data-snow')||'0',10);
    if(window.innerWidth<700)amount=Math.round(amount*.55);
    for(var i=0;i<amount;i++)flakes.push(newFlake(false));
    window.addEventListener('resize',fxSize);
    requestAnimationFrame(fxLoop);
  }

  /* ---------- pojawianie przy przewijaniu ---------- */
  var io=('IntersectionObserver' in window)?new IntersectionObserver(function(es){
    es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}});
  },{threshold:.12}):null;
  function initReveal(root){
    root.querySelectorAll('.xm-reveal:not(.is-in)').forEach(function(el){if(io)io.observe(el);else el.classList.add('is-in');});
  }

  /* ---------- odliczanie do świąt ---------- */
  function pad(n){return(n<10?'0':'')+n;}
  function initCountdown(root){
    root.querySelectorAll('[data-xm-countdown]:not([data-on])').forEach(function(el){
      el.setAttribute('data-on','1');
      var m=parseInt(el.getAttribute('data-month')||'12',10),d=parseInt(el.getAttribute('data-day')||'24',10);
      var tiles=el.querySelector('[data-tiles]'),done=el.querySelector('[data-done]');
      function tick(){
        var now=new Date(),t=new Date(now.getFullYear(),m-1,d),diff=t-now;
        if(diff<=0){
          if(diff>-3*864e5){if(tiles)tiles.hidden=true;if(done)done.hidden=false;return;}
          t=new Date(now.getFullYear()+1,m-1,d);diff=t-now;
        }
        var s=Math.floor(diff/1000),v={d:Math.floor(s/86400),h:Math.floor(s%86400/3600),m:Math.floor(s%3600/60),s:s%60};
        for(var k in v){var n=el.querySelector('[data-u="'+k+'"]');if(n)n.textContent=k==='d'?v[k]:pad(v[k]);}
      }
      tick();setInterval(tick,1000);
    });
  }

  /* ---------- interaktywne demo kurtyny LED ---------- */
  function initDemo(root){
    root.querySelectorAll('[data-xm-demo]:not([data-on])').forEach(function(box){
      box.setAttribute('data-on','1');
      var cv=box.querySelector('canvas');if(!cv)return;
      var ctx=cv.getContext('2d'),N=20,px=[],ph=[],mode='tree',paint='#ff3d5a',t=0,S=0,onScreen=true,touched=false,autoI=0;
      var screen=box.querySelector('.xm-demo__screen'),colors=box.querySelector('.xm-demo__colors');
      var AUTO=['tree','rainbow','heart','music','star','snow'];
      for(var i=0;i<N*N;i++){px[i]=null;ph[i]=Math.random()*6.28;}
      function clear(){for(var i=0;i<N*N;i++)px[i]=null;}
      function set(x,y,c){if(x>=0&&x<N&&y>=0&&y<N)px[y*N+x]=c;}
      function pick(a){return a[Math.floor(Math.random()*a.length)];}
      var draw={
        tree:function(){clear();set(9,0,'#ffc93c');set(10,0,'#ffc93c');set(9,1,'#ffc93c');set(10,1,'#ffc93c');
          for(var k=0;k<3;k++)for(var r=0;r<5;r++){var y=2+k*5+r,hw=Math.floor(1+r+k*1.5);
            for(var x=10-hw;x<=9+hw;x++)set(x,y,Math.random()<.16?pick(['#ff3d5a','#ffc93c','#4cc3ff','#ff5fb7']):'#1fd18a');}
          for(var y2=17;y2<20;y2++){set(9,y2,'#c9772b');set(10,y2,'#c9772b');}},
        heart:function(){clear();for(var y=0;y<N;y++)for(var x=0;x<N;x++){var u=(x-9.5)/7.2,v=(10.2-y)/7.2,f=Math.pow(u*u+v*v-1,3)-u*u*v*v*v;
            if(f<=0)set(x,y,Math.random()<.25?'#ff5fb7':'#ff3d5a');}},
        star:function(){clear();var s=6.2832/5,R=9.6,r2=4;
          for(var y=0;y<N;y++)for(var x=0;x<N;x++){var dx=x-9.5,dy=y-10.2,r=Math.sqrt(dx*dx+dy*dy),a=Math.atan2(dx,-dy),am=((a%s)+s)%s,b=Math.min(am,s-am);
            var lim=R*r2*Math.sin(s/2)/(R*Math.sin(b)+r2*Math.sin(s/2-b));
            if(r<=lim)set(x,y,r<3?'#fff3c4':'#ffc93c');}}
      };
      var live={
        rainbow:function(x,y){return'hsl('+Math.round((x*11+y*11+t*70)%360)+',100%,60%)';},
        music:function(x,y){var c=Math.floor(x/2),h=N*(.18+.8*Math.abs(Math.sin(t*3.1+c*.9)*Math.sin(t*1.7+c*.45)));
          return(N-y)<=h?'hsl('+Math.round(300-(N-y)*15)+',100%,60%)':null;},
        snow:function(x,y){var o=(x*7+3)%9,p=(((y-Math.floor(t*5)+o*3)%9)+9)%9;return p===0?(x%3?'#ffffff':'#4cc3ff'):null;}
      };
      function size(){var w=cv.clientWidth,d=Math.min(window.devicePixelRatio||1,2);if(!w)return;cv.width=w*d;cv.height=w*d;S=w*d;}
      function frame(){
        if(onScreen&&!document.hidden&&S){
          t+=reduced?0:.016;
          var cell=S/N,rad=cell*.26;
          ctx.clearRect(0,0,S,S);
          ctx.strokeStyle='rgba(255,255,255,.07)';ctx.lineWidth=1;
          for(var x=0;x<N;x++){ctx.beginPath();ctx.moveTo((x+.5)*cell,0);ctx.lineTo((x+.5)*cell,S);ctx.stroke();}
          var fn=live[mode];
          for(var y=0;y<N;y++)for(var x2=0;x2<N;x2++){
            var i=y*N+x2,c=fn?fn(x2,y):px[i],cx=(x2+.5)*cell,cy=(y+.5)*cell;
            if(!c){ctx.globalAlpha=1;ctx.fillStyle='rgba(255,255,255,.1)';ctx.beginPath();ctx.arc(cx,cy,rad*.45,0,6.28);ctx.fill();continue;}
            var tw=.78+.22*Math.sin(t*3+ph[i]);
            ctx.fillStyle=c;
            ctx.globalAlpha=.22*tw;ctx.beginPath();ctx.arc(cx,cy,rad*2.3,0,6.28);ctx.fill();
            ctx.globalAlpha=tw;ctx.beginPath();ctx.arc(cx,cy,rad,0,6.28);ctx.fill();
          }
          ctx.globalAlpha=1;
        }
        requestAnimationFrame(frame);
      }
      function setMode(m){
        var wasLive=!!live[mode];mode=m;
        if(draw[m])draw[m]();
        if(m==='diy'&&wasLive)clear();
        box.querySelectorAll('[data-mode]').forEach(function(b){b.classList.toggle('is-on',b.getAttribute('data-mode')===m);});
        if(colors)colors.hidden=m!=='diy';
        if(screen)screen.classList.toggle('is-diy',m==='diy');
      }
      box.querySelectorAll('[data-mode]').forEach(function(b){b.addEventListener('click',function(e){
        touched=true;setMode(b.getAttribute('data-mode'));
        if(window.xmConfetti)window.xmConfetti(e.clientX,e.clientY,14);
      });});
      box.querySelectorAll('[data-color]').forEach(function(b){b.addEventListener('click',function(){
        paint=b.getAttribute('data-color');
        box.querySelectorAll('[data-color]').forEach(function(o){o.classList.toggle('is-on',o===b);});
      });});
      var clr=box.querySelector('[data-clear]');if(clr)clr.addEventListener('click',clear);
      var down=false;
      function paintAt(e){var r=cv.getBoundingClientRect(),x=Math.floor((e.clientX-r.left)/r.width*N),y=Math.floor((e.clientY-r.top)/r.height*N);set(x,y,paint);}
      cv.addEventListener('pointerdown',function(e){
        touched=true;
        if(mode!=='diy'){setMode('diy');return;}
        down=true;paintAt(e);
      });
      cv.addEventListener('pointermove',function(e){if(down&&mode==='diy')paintAt(e);});
      window.addEventListener('pointerup',function(){down=false;});
      setInterval(function(){if(touched||!onScreen||reduced)return;autoI=(autoI+1)%AUTO.length;setMode(AUTO[autoI]);},3800);
      if('IntersectionObserver' in window)new IntersectionObserver(function(es){onScreen=es[0].isIntersecting;if(onScreen)size();}).observe(cv);
      window.addEventListener('resize',size);
      size();setMode('tree');requestAnimationFrame(frame);
    });
  }

  function init(root){initReveal(root);initCountdown(root);initDemo(root);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){init(document);});else init(document);
  document.addEventListener('shopify:section:load',function(e){init(e.target);});
})();
